<template>
  <div class="share-manage-container">
    <w-nav-bar nav_title="谁看过我" @mobileLeftBtn="pageBack"/>
    <div class="share-manage-header">
      <div class="share-manage-switch-item flex-between">
        <div class="flex-column manage-item-text">
          <span>简历追踪</span>
          <span class="subtitle-text">{{ cvSettings.public_visibility ? "已开启，获得链接的人可查看这份简历" : "已关闭，获得链接的人无法查看这份简历"}}</span>
        </div>
        <div class="switch-content flex-start" @click.prevent="changeSwitchValue('public_visibility')">
          <cube-switch v-model="cvSettings.public_visibility" :class="{'switch-close': !cvSettings.public_visibility}"/>
        </div>
      </div>
      <div class="share-manage-switch-item flex-between w-transition" :class="{'comment-switch': cvSettings.public_visibility}">
        <div class="flex-column manage-item-text">
          <span>允许查看者点评简历</span>
           <span class="subtitle-text">{{ cvSettings.can_comment ? "已开启，可以请好友帮忙改简历" : "已关闭，别人看不到简历评论且不可点评"}}</span>
        </div>
        <div class="switch-content" @click.prevent="changeSwitchValue('can_comment')">
          <cube-switch v-model="cvSettings.can_comment" :class="{'switch-close': !cvSettings.can_comment}"/>
        </div>
      </div>
    </div>
    <div class="share-auth-container" v-if="totalCount">
      <p class="auth-total">已有
        <span class="count-high-light">{{totalCount}}</span>
        位好友查看了你的简历
      </p>
      <div class="auths-scroll-container" :class="{'scroll-container-disabled-comment': !cvSettings.public_visibility}">
        <cube-scroll :data="userList" :options="options" @pulling-up="onPullingUp">
          <template v-for="(item, index) in userList">
            <div :key="index" class="flex-between auth-item" @click="changeSelectAuthorityState(item)">
              <div class="auth-infos flex-start">
                <img class="auth-avatar" :src="item.avatar" alt="" @click="onAppDownload">
                <div class="info flex-column">
                  <span class="auth-name" @click="onAppDownload">{{ item.name }}</span>
                  <span class="auth-time">上次查看：{{ item.updated_at | timeFilter(`MM-DD HH:mm`) }}</span>
                </div>
              </div>
              <div class="auth-authority flex-center" 
                   :class="[{'auth-authority-disabled-viewed': !item.visibility}, {'auth-authority-disabled': !cvSettings.public_visibility}]">
                <span class="authority-text">{{(cvSettings.public_visibility ? item.visibility : '不可见') | visiblityFilter}}</span>
                <i class="iconfont iconxiala" />
              </div>
            </div>
          </template>
        </cube-scroll>
      </div>
    </div>
    <w-no-result class="no-result-container" :class="{'no-result-container-disabled-comment': !cvSettings.public_visibility}"
                 v-else-if="!totalCount" text="发送链接给好友，请他（她）帮忙点评简历吧" />
    <select-authority :authority-state="authorityState"
                      :current-operation-user="currentOperationUser"
                      @changeAuthVisibility="changeAuthVisibility"
                      @handleClose="changeSelectAuthorityState"></select-authority>
  </div>
</template>

<script>
  import WNavBar from '../../components/global/w-navbar'
  import SelectAuthority from './Components/SelectAuthority'
  import WNoResult from '../../components/global/w-no-result'
  import { userMixin } from '../../assets/js/mixin/user'
  import { cvShareMixin } from '../../assets/js/mixin/cv'
  import { componentsMixin } from '../../assets/js/mixin/components'
  export default {
    mixins: [ userMixin, componentsMixin, cvShareMixin ],
    data(){
      return {
        authorityState: false, // 设置单人权限弹窗
        userList: [], // 查看列表
        options: {
          pullUpLoad: true
        },
        cvSettings: { // 当前简历设置
          public_visibility: false,
          comment: false,
          visibility_type: false
        },
        loadMore: true, // 加载更多
        currentOperationUser: {}, // 当前操作权限的用户
        totalCount: null,
        page: 1
      }
    },
    mounted() {
      this.getAuthsByToken()
      this.getSettingsValue()
      this.updateOwnerViewListTime()
    },
    components: {
      WNavBar,
      SelectAuthority,
      WNoResult
    },
    watch: {},
    computed: {},
    methods: {
      onPullingUp() {
        if (this.loadMore) {
          this.page += 1
          this.getAuthsByToken()
        }
      },
      // 页面返回事件
      pageBack() {
        this.$router.back()
      },
      // 修改当前简历权限
      changeSwitchValue(type) {
        // this.$nextTick(() => {
        //   this.cvSettings[type] = !this.cvSettings[type]
        // })
        this.debounce(() => this.changeSettingsValue(type), 300)
      },
      // 权限选择窗状态改变
      changeSelectAuthorityState(item) {
        if (this.cvSettings.public_visibility) {
          this.authorityState = !this.authorityState
          if (this.authorityState) {
            this.currentOperationUser = item
          } else {
            this.currentOperationUser = {}
          }
        }
      },
      // 更改权限
      async changeAuthVisibility(visibility) {
        try {
          let {token} = this.$route.params
          let res = await this.$api.cvShare.updateAuthorityByToken(token, this.currentOperationUser.token, {
            visibility
          })
          if (res.code === 1000) {
            this.currentOperationUser.visibility = visibility
            this.changeSelectAuthorityState()
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 获取分享简历查看列表
      async getAuthsByToken() {
        try {
          let { token } = this.$route.params 
          let res = await this.$api.cvShare.getAuthsByToken(token, {
            page: this.page,
            size: 10
          })
          if (res.code === 1000) {
            this.userList = this.page === 1 ? res.data.users : [...this.userList, ...res.data.users]
            this.loadMore = this.userList.length < res.data.total_count
            this.totalCount = res.data.total_count
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 修改owner查看访问列表时间
      updateOwnerViewListTime() {
        let {token} = this.$route.params
        this.$api.cvShare.updateOwnerViewListTime(token, this.cvAccountToken)
      },
      // 引导app下载
      onAppDownload() {
        console.log("app downlaod...")
         this.$router.push({
           path: '/welcome/to_app',
           query: {type: 'person'}
         })
      }
    },
    filters: {
      visiblityFilter(val) {
        if (typeof val !== 'number') {
          return val
        } else {
          return val === 20 ? '完整可见' : val === 10 ? '保护隐私' : '不可见'
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import './index';
</style>